var map = {
	"./asthma.svg": 41290,
	"./curve.svg": 401,
	"./diabetes.svg": 16055,
	"./edit.svg": 58908,
	"./hepatitis-a.svg": 6129,
	"./hepatitis-b.svg": 85762,
	"./hepatitis-c.svg": 90931,
	"./hiv.svg": 61397,
	"./hypertension.svg": 88416,
	"./minus.svg": 29200,
	"./patientProfile.svg": 92734,
	"./plus.svg": 40536,
	"./rh-negative.svg": 11614,
	"./sickle-cell.svg": 50112,
	"./trash.svg": 28590,
	"./ulcer.svg": 16443,
	"./view.svg": 91683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99502;